module.exports = __webpack_public_path__ + "img/zh.003774a4.png";